import {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {PATHS} from "@/constants/routes";
import {RegistrationPage} from "@/pages/auth/Registration";
import {useAuthStore} from "@/store/auth.store";

const RegistrationRoute = () => {
  const navigate = useNavigate();
  const status = useAuthStore(state => state.status);
  const hydrate = useAuthStore(state => state.hydrate);

  useEffect(() => {
    if (status === "checking") hydrate();
  }, [status, hydrate]);

  useEffect(() => {
    if (status === "authenticated") navigate(PATHS.home, {replace: true});
  }, [status, navigate]);

  return (
    <main className="flex min-h-screen w-full items-center justify-center bg-[var(--color-bg)] px-4 py-8">
      <RegistrationPage onSuccess={() => navigate(PATHS.home, {replace: true})} />
    </main>
  );
};

export default RegistrationRoute;
